<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <presupuesto-list
        ref="list"
        @show="show"
        @edit="edit"
        @refreshed="refetchList"
      />
    </template>

    <presupuesto-pedido-desde-productos-create
      v-if="creating"
      :open="creating"
      :items="[]"
      :presupuesto-id="editingPresupuestoId"
      tipo-documento-fijo="presupuesto"
      @created="onItemCreated"
      @close="onCreateClose"
    />

    <presupuesto-show
      v-if="showing"
      :open="showing"
      :presupuesto-id="selectedId"
      @close="showing = false"
      @confirmar="onConfirmar"
      @refreshed="refetchList"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import { CrudLayout, Snackbar } from "@dracul/common-frontend";
import PresupuestoList from "../PresupuestoList";
import PresupuestoPedidoDesdeProductosCreate from "../../../../producto/pages/ProductoManagementPage/PresupuestoPedidoDesdeProductosCreate";
import PresupuestoShow from "../PresupuestoShow";

export default {
  name: "PresupuestoCrud",
  components: {
    CrudLayout,
    Snackbar,
    PresupuestoList,
    PresupuestoPedidoDesdeProductosCreate,
    PresupuestoShow,
  },
  data() {
    return {
      title: "Presupuestos",
      subtitle: "Cotizaciones y presupuestos para clientes",
      flash: null,
      creating: false,
      showing: false,
      selectedId: null,
      editingPresupuestoId: null,
    };
  },
  methods: {
    create() {
      this.editingPresupuestoId = null;
      this.creating = true;
    },
    edit(item) {
      this.editingPresupuestoId = item.id;
      this.creating = true;
    },
    show(item) {
      this.selectedId = item.id;
      this.showing = true;
    },
    onCreateClose() {
      this.creating = false;
      this.editingPresupuestoId = null;
    },
    onItemCreated(wasUpdate) {
      const message = wasUpdate ? "Presupuesto actualizado" : "Presupuesto creado";
      this.creating = false;
      this.editingPresupuestoId = null;
      this.refetchList();
      this.flash = message;
    },
    onConfirmar() {
      this.showing = false;
      this.refetchList();
      this.$router.push({ name: "OrdenVentaManagementPage", params: {}, query: {} });
    },
    refetchList() {
      this.$refs.list && this.$refs.list.fetch();
    },
  },
};
</script>
